import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { captureFrontendError } from '@/lib/sentry';

// Build-time key (publishable, safe to ship). Single promise — Stripe.js must
// not be loaded more than once per page.
const publishableKey: string | undefined = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || undefined;

/** AIT-494 — a build shipped without the key must fail loud and visible, not
 *  die inside Stripe.js with an uncaught IntegrationError and a forever-blank
 *  card form (that is exactly how staging shipped broken for 10 weeks). */
export function isStripeConfigured(): boolean {
  return !!publishableKey;
}

let promise: Promise<Stripe | null> | null = null;
export function getStripe(): Promise<Stripe | null> {
  if (!promise) {
    if (!publishableKey) {
      // console for the developer, Sentry for monitoring — customer browsers'
      // consoles are never collected (CodeRabbit PR #260).
      console.error('VITE_STRIPE_PUBLISHABLE_KEY is missing from this build — card entry is disabled (AIT-494)');
      captureFrontendError(new Error('VITE_STRIPE_PUBLISHABLE_KEY missing from build — card entry disabled'), {
        context: 'getStripe',
      });
      promise = Promise.resolve(null);
    } else {
      promise = loadStripe(publishableKey);
    }
  }
  return promise;
}
